import { render } from "./InvoiceList.vue?vue&type=template&id=b405c7d8"
import script from "./InvoiceList.vue?vue&type=script&lang=js"
export * from "./InvoiceList.vue?vue&type=script&lang=js"

import exportComponent from "/Users/souban/Documents/Code/Pitch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__